export default __webpack_public_path__ + "static/media/notes.482e4230.svg";